import React from "react";

// Unauthorized access page
const UnauthorizedPage = () => {
  return <h1>403 - Unauthorized</h1>;
};

export default UnauthorizedPage;
